import React, { useEffect, useRef, useState } from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import { useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import { DEFAULT_TOPIC } from '../../constants'
import TopicChip from '../TopicChip'

import classes from './TopicsCarousel.module.scss'

const ARROWS_FOR_DESKTOP = 24

/** @type {import("./types").default} */
const TopicsCarousel = ({ activeChip, fetchOnClick, topics }) => {
  const { addEvent } = useEventContext()
  const [scroll, setScroll] = useState(classes.rightShadow)
  const carouselRef = useRef()
  const { up } = useViewport()
  const carouselItems = [DEFAULT_TOPIC, ...topics]

  const hasRightShadow = scroll.includes('right')
  const hasLeftShadow = scroll.includes('left')

  useEffect(() => {
    const carouselRefCurrent = carouselRef.current
    if (carouselRefCurrent) {
      const onscroll = e => {
        if (e.target.scrollLeft <= 0) return setScroll(classes.rightShadow)
        if (e.target.scrollLeft + e.target.offsetWidth + ARROWS_FOR_DESKTOP >= carouselRefCurrent.scrollWidth)
          return setScroll(classes.leftShadow)
        setScroll(clsx(classes.rightShadow, classes.leftShadow))
      }
      carouselRefCurrent.addEventListener('scroll', onscroll)
    }
    return () => carouselRefCurrent && carouselRefCurrent.removeEventListener('scroll', onscroll)
  }, [carouselRef])

  const handleArrowClick = direction => () =>
    carouselRef.current.scrollBy({
      left: direction === 'left' ? -300 : 300,
      behaviour: 'smooth',
    })

  return (
    <>
      <div className={clsx('TopicsCarousel', classes.root)}>
        <div className={classes.carousel} ref={carouselRef}>
          <div className={clsx(classes.topicsContainer)}>
            {carouselItems.map(topic => (
              <TopicChip
                key={topic.slug}
                topic={topic}
                activeChip={activeChip}
                fetchOnClick={fetchOnClick}
                size={up('md') ? 'medium' : 'small'}
              />
            ))}
          </div>
        </div>
        {hasLeftShadow && (
          <div className={clsx(classes.leftShadow)} data-testid="carousel-slide-left">
            {up('md') && (
              <Icon
                onClick={handleArrowClick('left')}
                icon="chevron-right"
                size={16}
                {...addEvent({
                  engagementComponent: 'content_type',
                  engagementDestination: 'slide-to_left',
                  engagementDetails: 'slider-arrow',
                  name: 'engagement_navigation',
                })}
              />
            )}
          </div>
        )}
        {hasRightShadow && (
          <div className={clsx(classes.rightShadow)} data-testid="carousel-slide-right">
            {up('md') && (
              <Icon
                onClick={handleArrowClick('right')}
                icon="chevron-right"
                size={16}
                {...addEvent({
                  engagementComponent: 'content_type',
                  engagementDestination: 'slide-to_right',
                  engagementDetails: 'slider-arrow',
                  name: 'engagement_navigation',
                })}
              />
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default TopicsCarousel
